<span class="p-0 d-flex flex-column align-content-center">
  <span class="title capitalize">
    <strong><i class="icon icon-disney">&nbsp;</i>{{item['itemInfo']['hotel']['title'] | lowercase}}</strong>
  </span>
  <span class="p-0 spaced">
    <span class="subtitle">{{item.nights}}
      <i class="icon-moon-phase-outline" aria-hidden="true"></i> |
      {{item['itemInfo']['hotel']['additionalInfo']['stars']}}
      <i class="icon-estrella" aria-hidden="true"></i> | 1 Room
    </span>
  </span>
  <span class="p-0 spaced">
    <p class="p-0 description inter capitalize">
      {{item['itemInfo']['room']['roomType'] | lowercase}}
    </p>
  </span>
  <span class="p-0 spaced">
    <p class="p-0 description inter">
      <i class="icon-restaurant icon" ></i> {{(item['itemInfo']['mealPlan'] !== undefined) && (item['itemInfo']['mealPlan'] !== null)? item['itemInfo']['mealPlan']['title'] : 'None'}}
    </p>
  </span>
  <span class="p-0 spaced">
    <p class="p-0 description inter">
      <i class="icon-actividades_exterior icon" ></i> {{item['itemInfo']['ticket'] !== undefined? item['itemInfo']['ticket']['title'] + '|' + item['itemInfo']['days'] : 'None'}}</p>
  </span>
</span>